<ion-app>
    @if (authController.isLogged()) {
    <bm-aside></bm-aside>
    }
    <ion-router-outlet id="main"></ion-router-outlet>
    <quang-toast></quang-toast>
    <quang-loader>
        <div loader>
            <div class="spinner-border" role="status">
            </div>
        </div>
    </quang-loader>
</ion-app>